import { toast } from "react-toastify";
import { useProductSubscriptionMutation, useProductSubscriptionsStore } from "../providers/products";
import { Product } from "@core/types";
import { useAuth } from "../contexts/auth-context";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

interface UseAddProductSubscriptionReturn {
  handleAddProductSubscription: () => void;
  isLoading: boolean;
  isError: boolean;
}

const useAddProductSubscription = (productId: Product["id"]): UseAddProductSubscriptionReturn => {
  const history = useHistory();
  const { isUserAuthenticated } = useAuth();
  const { addProductSubscription } = useProductSubscriptionsStore();
  const { t } = useTranslation();
  const {
    mutate: addProductSubscriptionMutate,
    isLoading,
    isError,
  } = useProductSubscriptionMutation({
    productId: productId,
    options: {
      onSuccess: (data) => {
        if (data) {
          toast.success(t("Product subscription added"));
          addProductSubscription(data.productId);
        }
      },
      onError: (error) => {
        console.error("Failed to add product subscription:", error);
        toast.error(t("Error adding product subscription"));
      },
    },
  });

  const handleAddProductSubscription = () => {
    if (isUserAuthenticated) {
      addProductSubscriptionMutate();
    } else {
      history.push("/auth");
    }
  };

  return {
    handleAddProductSubscription,
    isLoading,
    isError,
  };
};

export default useAddProductSubscription;
